export enum FilterTypes {
  National,
  SubNational,
  City,
  Company,
}
